import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '@/contexts'

export function ProtectedRoutes() {
  const { signed } = useAuth()

  if (!signed) {
    return <Navigate to="/login" />
  }

  return <Outlet />
}
